import React from 'react';
import { Select, MenuItem, InputBase } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import { useSelector } from 'react-redux';
import * as UserSelectors from 'selectors/UserSelectors';
import { RiArrowDownSFill } from 'react-icons/ri';

import { useTranslation } from 'services/localization';

interface Props {
	locationType: 'all' | 'current';
	onLocationTypeChange: (type: 'all' | 'current') => void;
}
const LocationTypeSelect = (props: Props) => {
	const { t } = useTranslation();
	const { locationType, onLocationTypeChange } = props;
	const activeLocation = useSelector(UserSelectors.userActiveLocation);

	return (
		<Select
			value={locationType}
			variant="outlined"
			input={<SimpleInput />}
			IconComponent={RiArrowDownSFill}
			onChange={(e) => onLocationTypeChange(e.target.value as 'current' | 'all')}
			sx={{ '.MuiSelect-icon': { top: 'auto' } }}
		>
			<MenuItem value="current">{activeLocation?.name}</MenuItem>
			<MenuItem value="all">{t('common:shopLocation.allLocations')}</MenuItem>
		</Select>
	);
};

const SimpleInput = withStyles(() => ({
	input: {
		border: 'none',
		textTransform: 'uppercase',
		fontSize: 14,
		fontWeight: 500,
	},
}))(InputBase);

export default LocationTypeSelect;
